import React, { useState } from 'react'
import Paper from "@material-ui/core/Paper";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import MultiplicativeCipherSimulation from './MultiplicativeCipherSimulation';
import MultiplicativeCipherTheory from './MultiplicativeCipherTheory';
import MultiplicativeCipherAlgo from './MultiplicativeCipherAlgo';
import MultiplicativeCipherExercise from './MultiplicativeCipherExercise';


const MultiplicativeCipherPage = () => {
    const [value, setValue] = useState(0);
    const [selectedTab, setSelectedTab] = useState("Theory");

    return (
        <div>
            <h1>Multiplicative Cipher</h1>
            <Paper square style={{ width: "fit-content", minWidth: "100%" }}>
                <Tabs
                    value={value}
                    textColor="primary"
                    indicatorColor="primary"
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                >
                    <Tab label="Theory" onClick={() => { setSelectedTab("Theory") }} />
                    <Tab label="Algorithm" onClick={() => { setSelectedTab("Algorithm") }} />
                    <Tab label="Simulation" onClick={() => { setSelectedTab("Simulation") }} />
                    <Tab label="Exercise" onClick={() => { setSelectedTab("Exercise") }} />
                    {/* <Tab label="Disabled TAB!" disabled /> */}
                </Tabs>
                <div style={{ display: selectedTab === "Theory" ? "inline-block" : "none" }}>
                    <MultiplicativeCipherTheory />
                </div>

                <div style={{ display: selectedTab === "Algorithm" ? "inline-block" : "none" }}>
                    <MultiplicativeCipherAlgo />
                </div>

                <div style={{ display: selectedTab === "Simulation" ? "inline-block" : "none" }} >
                    <MultiplicativeCipherSimulation />
                </div>

                <div style={{ display: selectedTab === "Exercise" ? "inline-block" : "none" }} >
                    <MultiplicativeCipherExercise />
                </div>

            </Paper>
        </div>
    );
}

export default MultiplicativeCipherPage